module.exports = __webpack_public_path__ + "img/pic8.6ad2760e.png";